import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Accordion, Modal } from "react-bootstrap";
import Moment from "react-moment";
import { IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import ScrollContainer from "react-indiana-drag-scroll";

// Redux Actions
import { fetchSingleTrainerStats, STATUSES } from "../../redux/getReducer/getTrainerStatistics";
import { fetchtrainermodalstats } from "../../redux/getReducer/getTrainerModalstats";

// Reusable Components
import Pagination from "../../pages/Pagination";
import PleaseWait from "../Reuseable/PleaseWait";
import VideoFrame from "../Modal/VideoFrame";
import JockeyDetail from "../Modal/JockeyModal";
import HorseModal from "../Modal/HorseModal";
import RaceModal from "../Modal/RaceModal";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";

const Stats = ({ id }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookiedata = Cookies.get("i18next");

  // Redux Selectors
  const {
    data: singletrainerstats,
    totalcount,
    status: statsStatus,
  } = useSelector((state) => state.singletrainerstats);
  const { data: trainermodalstats } = useSelector((state) => state.trainermodalstats);

  const [activeAccordion, setActiveAccordion] = useState(null);
  const [currentYear, setCurrentYear] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 10;

  // Modal States
  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const [ShowJockey, setShowJockey] = useState(false);
  const [modaldatasJockey, setmodaldatasJockey] = useState();
  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const [ShowHorse, setShowHorse] = useState(false);
  const [modaldatasHorse, setmodaldatasHorse] = useState();

  // Handlers
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => {
    setmodaldatas(data);
    setShows(true);
  };
  const handleJockeyCloses = () => setShowJockey(false);
  const handleShowJockey = (data) => {
    const jId = data?._id || data;
    if (jId) navigate("/jockey-detail?" + jId);
  };
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => {
    const rId = data?._id || data;
    if (rId) navigate("/race-detail?" + rId);
  };
  const handleHorseCloses = () => setShowHorse(false);
  const handleShowHorse = (data) => {
    const hId = data?._id || data;
    if (hId) navigate("/horse-detail?" + hId);
  };

  useEffect(() => {
    setActiveAccordion(null);
    setCurrentPage(1);
    setCurrentYear("");
    dispatch(fetchSingleTrainerStats({ year: "", id, page: 1, size: postsPerPage }));
    dispatch(fetchtrainermodalstats({ id }));
  }, [dispatch, id]);

  const handleTrainerRecord = (selectedYear, index) => {
    if (activeAccordion === index) {
      setActiveAccordion(null);
    } else {
      setActiveAccordion(index);
      const y = selectedYear || "";
      setCurrentYear(y);
      setCurrentPage(1);
      dispatch(
        fetchSingleTrainerStats({
          year: y,
          id,
          page: 1,
          size: postsPerPage,
        })
      );
    }
  };

  const paginate = (pageNumber) => {
    if (pageNumber === "..." || pageNumber === currentPage) return;
    setCurrentPage(pageNumber);
    dispatch(
      fetchSingleTrainerStats({
        year: currentYear,
        id,
        page: pageNumber,
        size: postsPerPage,
      })
    );
  };

  const getActiveTotalPosts = () => {
    if (activeAccordion === "overall") {
      return Number(trainermodalstats?.OverAll?.Runs || totalcount || 0);
    }
    if (activeAccordion !== null && trainermodalstats?.data?.[activeAccordion]) {
      return Number(
        trainermodalstats.data[activeAccordion]?.Detail?.Runs || totalcount || 0
      );
    }
    return Number(totalcount || 0);
  };

  // Distance Label Logic
  function distanceLabel(distance, rank) {
    const DistanceTobeChecked = parseFloat(distance);
    if (DistanceTobeChecked.toFixed(2) > 25) return "Dist";
    else if (DistanceTobeChecked.toFixed(2) == 0.05 && rank < 80) return "SHd";
    else if (DistanceTobeChecked.toFixed(2) == 0.1 && rank < 80) return "Hd";
    else if (DistanceTobeChecked.toFixed(2) == 0.25 && rank < 80) return "Nk";
    else if (DistanceTobeChecked.toFixed(2) == 0.01 && rank < 80) return "Ns";
    else if (DistanceTobeChecked.toFixed(2) == 0.0 && rank < 80) return rank === 1 ? 0 : "Dh";
    else return distance;
  }

  return (
    <div className="my-new-stats-tab-wrapper">
      {/* --- MAIN HEADER --- */}
      <div className="my-new-stats-thead">
        <div>{t("Year")}</div>
        <div>{t("Runs")}</div>
        <div>{t("Wins")}</div>
        <div>{t("Second")}</div>
        <div>{t("Third")}</div>
        <div>{t("Fourth")}</div>
        <div>{t("Fifth")}</div>
        <div>{t("Earning")}</div>
        <div>{t("Wins")}%</div>
        <div>{t("Place")}%</div>
        <div></div>
      </div>

      <div className="my-new-stats-accordion-container">
        {/* 1. OVERALL STATS SECTION */}
        <Accordion activeKey={activeAccordion === "overall" ? "0" : ""}>
          <Accordion.Item
            eventKey="0"
            className="my-new-stats-acc-item"
          >
            <Accordion.Header
              className="my-new-stats-header-custom"
              onClick={() => handleTrainerRecord("", "overall")}
            >
              <div className="my-new-stats-header-grid">
                <div className="new-bold">OverAll</div>
                <div>{trainermodalstats.OverAll?.Runs}</div>
                <div>{trainermodalstats.OverAll?.wins}</div>
                <div>{trainermodalstats.OverAll?.second}</div>
                <div>{trainermodalstats.OverAll?.third}</div>
                <div>{trainermodalstats.OverAll?.fourth}</div>
                <div>{trainermodalstats.OverAll?.fifth}</div>
                <div className="new-bold">{Number(trainermodalstats.OverAll?.earning || 0).toLocaleString()}</div>
                <div>{Number(trainermodalstats.OverAll?.winspercentage || 0).toFixed(2)}</div>
                <div>{Number(trainermodalstats.OverAll?.placespercentage || 0).toFixed(2)}</div>
                <div style={{ textAlign: "right" }}>
                  {activeAccordion === "overall" ? (
                    <MdKeyboardArrowDown className="my-new-stats-arrow" />
                  ) : (
                    <MdKeyboardArrowRight className="my-new-stats-arrow" />
                  )}
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ padding: 0 }} onClick={(e) => e.stopPropagation()}>
              {activeAccordion === "overall" && (
                <InnerHistoryGrid
                  data={singletrainerstats}
                  t={t}
                  cookiedata={cookiedata}
                  handleShowRace={handleShowRace}
                  handleShowJockey={handleShowJockey}
                  handleShows={handleShows}
                  handleShowHorse={handleShowHorse}
                  distanceLabel={distanceLabel}
                  totalPosts={getActiveTotalPosts()}
                  currentPage={currentPage}
                  postsPerPage={postsPerPage}
                  paginate={paginate}
                  loading={statsStatus === STATUSES.LOADING}
                />
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* 2. YEARLY STATS LOOP */}
        {trainermodalstats?.data &&
          trainermodalstats.data.map((item, i) => (
            <Accordion key={i} activeKey={activeAccordion === i ? "0" : ""}>
              <Accordion.Item
                eventKey="0"
                className="my-new-stats-acc-item"
              >
                <Accordion.Header
                  className="my-new-stats-header-custom"
                  onClick={() => handleTrainerRecord(item.Years, i)}
                >
                  <div className="my-new-stats-header-grid">
                    <div className="new-bold">{item?.Years}</div>
                    <div>{item.Detail?.Runs}</div>
                    <div>{item.Detail?.wins}</div>
                    <div>{item.Detail?.second}</div>
                    <div>{item.Detail?.third}</div>
                    <div>{item.Detail?.fourth}</div>
                    <div>{item.Detail?.fifth}</div>
                    <div className="new-bold">{Number(item.Detail?.earning || 0).toLocaleString()}</div>
                    <div>{Number(item.Detail?.winspercentage || 0).toFixed(2)}</div>
                    <div>{Number(item.Detail?.placespercentage || 0).toFixed(2)}</div>
                    <div style={{ textAlign: "right" }}>
                      {activeAccordion === i ? (
                        <MdKeyboardArrowDown className="my-new-stats-arrow" />
                      ) : (
                        <MdKeyboardArrowRight className="my-new-stats-arrow" />
                      )}
                    </div>
                  </div>
                </Accordion.Header>
                <Accordion.Body style={{ padding: 0 }} onClick={(e) => e.stopPropagation()}>
                  {activeAccordion === i && (
                    <InnerHistoryGrid
                      data={singletrainerstats}
                      t={t}
                      cookiedata={cookiedata}
                      handleShowRace={handleShowRace}
                      handleShowJockey={handleShowJockey}
                      handleShows={handleShows}
                      handleShowHorse={handleShowHorse}
                      distanceLabel={distanceLabel}
                      totalPosts={getActiveTotalPosts()}
                      currentPage={currentPage}
                      postsPerPage={postsPerPage}
                      paginate={paginate}
                      loading={statsStatus === STATUSES.LOADING}
                    />
                  )}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))}
      </div>

      {/* Modals preserved */}
      <Modal show={shows} onHide={handleCloses} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><VideoFrame data={modaldatas} /></Modal.Body>
      </Modal>
      <Modal show={ShowJockey} onHide={handleJockeyCloses} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><JockeyDetail data={modaldatasJockey} /></Modal.Body>
      </Modal>
      <Modal show={showRace} onHide={handleCloseRace} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><RaceModal id={modaldataRace} /></Modal.Body>
      </Modal>
      <Modal show={ShowHorse} onHide={handleHorseCloses} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><HorseModal data={modaldatasHorse} /></Modal.Body>
      </Modal>
    </div>
  );
};

// --- HELPER COMPONENT FOR 16-COLUMN GRID WITH PAGINATION ---
const InnerHistoryGrid = ({
  data,
  t,
  cookiedata,
  handleShowRace,
  handleShowJockey,
  handleShows,
  handleShowHorse,
  distanceLabel,
  totalPosts,
  currentPage,
  postsPerPage,
  paginate,
  loading,
}) => {
  if (loading && (!data || data.length === 0)) {
    return <div className="text-center py-4"><PleaseWait /></div>;
  }
  if (!data || data.length === 0) {
    return <div className="text-center py-4">{t("No History Yet")}</div>;
  }

  return (
    <>
      <ScrollContainer className="my-new-stats-inner-scroll">
        <div className="my-new-stats-inner-table">
          <div className="my-new-stats-inner-thead">
            <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Horse Name")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div>{t("Link")}</div>
          </div>
          <div
            className="my-new-stats-inner-tbody"
            style={{ opacity: loading ? 0.5 : 1, transition: "opacity 0.2s ease-in-out" }}
          >
            {data.map((item, idx) => {
              const groundName = item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn;
              const rowBg = groundName === "Dirt" ? "#e3d4ca" : groundName === "Turf" ? "#cbedba" : "#949494";

              return (
                <div key={idx} className="my-new-stats-inner-row" style={{ backgroundColor: rowBg, color: "#343433" }}>
                  <div onClick={() => handleShowRace(item.RaceID)} className="new-clickable-white">
                    <Moment format="DD/MM/YYYY">{item.RaceResultData?.StartTime}</Moment>
                  </div>
                  <div>
                    {cookiedata === "en" ? item.RaceResultData?.RaceCourseData?.AbbrevEn : item.RaceResultData?.RaceCourseData?.AbbrevAr}({cookiedata === "en" ? item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn?.charAt(0) : item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameAr?.charAt(0)})
                  </div>
                  <div className="new-clickable-white" onClick={() => handleShowHorse(item.HorseIDData?._id)}>
                    {cookiedata === "en" ? toTitleCase(item.HorseIDData?.NameEn || "-") : (item.HorseIDData?.NameAr || "-")}
                  </div>
                  <div>{item.RaceResultData?.TrackLengthData?.TrackLength}</div>
                  <div className="new-truncate-cell">
                    <span>{cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData?.RaceTypeModelData?.NameEn)) : item.RaceResultData?.RaceTypeModelData?.NameAr}</span>
                  </div>
                  <div>{item.RaceResultData?.RaceTime || "-"}</div>
                  <div onClick={() => handleShowJockey(item.JockeyOnRaceDataResult?._id)} className="new-clickable-white">{cookiedata === "en" ? toTitleCase(item.JockeyOnRaceDataResult?.ShortNameEn) : item.JockeyOnRaceDataResult?.ShortNameAr}</div>
                  <div>{item.HorseIDData ? item.HorseIDData.BeatenByJockeyWeight : 0}</div>
                  <div>{cookiedata === "en" ? toTitleCase(item.FinalPositionDataHorse?.NameEn) : item.FinalPositionDataHorse?.NameAr}</div>
                  <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>
                  <div>{item.RaceResultData?.Runners}</div>
                  <div className="new-truncate-cell new-clickable-white" onClick={() => handleShowHorse(item.BeatenByData?._id || item.BeatenByData)}>
                    {item.BeatenByData ? toTitleCase(cookiedata === "en" ? item.BeatenByData?.NameEn : item.BeatenByData?.NameAr) : toTitleCase(cookiedata === "en" ? item.HorseIDData?.HorseBeatenByEnglishName : item.HorseIDData?.HorseBeatenByArabicName)}
                  </div>
                  <div>{item.BeatenByData?.WinningHorseJockeyWeight?.toFixed(1) || 0}</div>
                  <div>{item.RaceResultData?.Draw || item.HorseNo || "-"}</div>
                  <div>{item.Rating || 0}</div>
                  <div onClick={() => handleShows(item.VideoLink)} className="my-new-play-btn-circle">
                    <IoMdPlay />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </ScrollContainer>
      {totalPosts > postsPerPage && (
        <div className="new-tranier-modal-pagination-wrapper py-2">
          <Pagination
            postsPerPage={postsPerPage}
            totalPosts={totalPosts}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      )}
    </>
  );
};

export default Stats;
